// extracted by mini-css-extract-plugin
export var actionButton = "_d2-0";
export var fileInput = "_d2-2";
export var paperclip = "_d2-1";